<template>
  <fragment>

    <fragment>
      <div class="container border">
        <h6>Add Actions</h6>
        <div class="row ">
          <label class="col-sm-2 mb-sm-0">Status:</label>
          <app-input class="col-sm-8"
                     type="select"
                     :list="statusList"
                     v-model="status"
                     :required="true"/>
          <div class="col-sm-2"></div>
          <label class="col-sm-2 mb-sm-0">Write a comment:</label>
          <app-input
              class="col-sm-8 direction-input"
              type="textarea"
              v-model="commentText"
              placeholder="Write Comment"
          />
          <multi-upload-btn
              :uploadedFile="this.uploadedFile"
              :emailAddress="this.emailAddress"
          />
          <div class="col-sm-12">
            <el-button class="secondary mt-2"
                       @click="saveComment()">
              Save Comment
            </el-button>

          </div>
        </div>
      </div>

    </fragment>
    <fragment>

      <comments-steps-tree :steps="steps"
                           @node-delete="deleteNode"
                           @node-edit="editNode"
      />
    </fragment>

  </fragment>
</template>

<script>
import {Comment} from "@Views/Screening/utility/apiAgent";
import {_status, oralSteps, writtenSteps} from "@Views/Screening/utility/constant";
import {updateCommentSteps} from "@Views/Screening/utility/common/comment";

export default {
  name: "GeneralComments",
  props: {
    comments: {
      type: Array,
      default: () => []
    },
    emailAddress: {
      type: String
    },
    applicantId: {
      type: Number,
    },
    statusable_type: {
      type: String
    },
    statusable_id: {
      type: Number,
    }
  },
  data() {
    return {
      steps: [],
      commentText: '',
      status: '',
      uploadedFile: [],
      statusList: _status,
      oralSteps: oralSteps,
      writtenSteps: writtenSteps
    };
  },
  created() {
    this.setStepsOnInitialization();
  },
  methods: {
    updateCommentSteps,
    saveComment() {
      if (this.commentText != '') {
        const commentObj = {
          statusable_type: this.statusable_type,
          statusable_id: this.statusable_id,
          status: this.status,
          action_comment: this.commentText,
          applicant_files: this.uploadedFile.map(x => x.id)
        };
        Comment.saveComment(this.applicantId, commentObj)
            .then(({data}) => {
              this.comments.push({id: data.screeningStatus.id, ...commentObj});
              this.updateCommentSteps({id: data.screeningStatus.id, ...commentObj}, false);
              this.status = '';
              this.uploadedFile.splice(0);
              this.$hub.$emit('clear-uploaded-files');
              this.commentText = '';
              this.$toastr.s(data.message);
              //todo need to add condition for search only - trigger
              this.$hub.$emit('pass-steps-in-search-case', data.screeningStatus);

            });
      }else if (this.statusable_type === null || this.statusable_type === undefined){
        this.$toastr.i("Comment type is missing.");
      }else{
        this.$toastr.i("Comment is required.");
      }
    },
    deleteNode(event) {
    },
    editNode(event) {
    },
    setStepsOnInitialization() {
      for (const _comment of this.comments) {
        const o = {
          id: _comment.id,
          include_in_report: _comment.include_in_report,
          action_comment: _comment.action_comment,
          status: _comment.status,
          applicant_files: _comment.applicant_files,
          statusable_id: _comment.statusable_id,
          statusable_type: _comment.statusable_type
        };
        this.updateCommentSteps(o, true);
      }
    },
  }
}
</script>

<style scoped>
.direction-input {
  direction: ltr;
}

.direction-label {
  text-align: left;
}
</style>